module.exports = __webpack_public_path__ + "img/media_6.b73b39b0.jpg";